// useConfirm.ts
import { useState, useCallback } from "react";

export const useCustomImageModal = () => {
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [joNo, setJoNo] = useState<string>("");
  const [status, setStatus] = useState<string>("");
  const [image, setImage] = useState<string>("");
  const [remarks, setRemarks] = useState<string>("");

  const customImageModal = useCallback(
    (
      imageString: string,
      remarksString: string,
      joNo: string,
      status: string
    ) => {
      setImage(imageString);
      setRemarks(remarksString);
      setIsImageModalOpen(true);
      setJoNo(joNo);
      setStatus(status);
    },
    []
  );

  const handleImageModalClose = () => {
    setIsImageModalOpen(false);
    setImage("");
    setRemarks("");
    setJoNo("");
    setStatus("");
  };

  return {
    isImageModalOpen,
    customImageModal,
    handleImageModalClose,
    image,
    remarks,
    joNo,
    status,
  };
};
